<template>
  <CardViewer
    class="app-viewer"
    :text="text"
    :icon="icon"
    :fill="fill"
    :color="color"
    :cover="cover"
    :cardLayout="cardLayout"
    :isFullscreen="isFullscreen"
    cardClassName="app-card"
  >
    <AppIframe class="app-view-content" :src="src" :studentId="studentId" />
    <template #fullscreen>
      <AppIframe :src="src" :studentId="studentId" />
    </template>
  </CardViewer>
</template>

<script>
import CardViewer from './CardViewer'
import AppIframe from './AppIframe'

export default {
  name: 'app-viewer',
  components: {
    CardViewer,
    AppIframe,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
    },
    color: {
      type: String,
    },
    cover: {
      type: String,
    },
    cardLayout: {
      type: String,
      default: '',
    },
    studentId: {
      type: String,
      default: '',
    },
  },
  computed: {
    isFullscreen() {
      return ['bb', 'intex', 'mi', 'tr', 'cs'].includes(this.type)
    },
  },
}
</script>

<style lang="scss" scoped>
.app-view-content {
  width: 100%;
  height: 618px;
  position: relative;
  z-index: 1;
  border: 0;
  border-radius: 10px;
}
</style>